// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__IQ9oI","boxTitle":"Qualiphy_boxTitle__fVJ_F","box":"Qualiphy_box__A89X6","toggleWrap":"Qualiphy_toggleWrap__1QtLq"};